import React from 'react';
import Heading from '@kiwicom/orbit-components/lib/Heading';
import Inline from '@kiwicom/orbit-components/lib/Inline';
import Stack from '@kiwicom/orbit-components/lib/Stack';
import { Sector as SectorType } from '@kiwicom/openapi-sdk/mmb';
import { ItinerarySeparator } from '@kiwicom/orbit-components/lib/Itinerary';
import Clock from '@kiwicom/orbit-components/lib/icons/Clock';
import Text from '@kiwicom/orbit-components/lib/Text';

import SegmentGroup from './SegmentGroup';
import ItineraryBadgeList from './ItineraryBadgeList';
import formatDuration from '../../../services/helpers/formatDuration';

const SectorHeader = ({ sector }: { sector: SectorType }) => {
  return (
    <Stack justify="between" spaceAfter="normal">
      <Heading type="title3" as="h2">
        {sector.title}
      </Heading>
      {sector.duration && (
        <Inline align="center" spacing="100">
          <Clock ariaHidden /> <Text>{formatDuration(sector.duration.value)}</Text>
        </Inline>
      )}
    </Stack>
  );
};

type SectorProps = {
  sector: SectorType;
};

/**
 * Component which renders one sector of Itinerary. It can contain a title, duration, segment groups
 * and info about the stay (title and badges)
 *
 * @param sector - {@link SectorType} object, which is part of server-driven Itinerary
 *
 * @returns Sector component
 */
const Sector = ({ sector }: SectorProps) => {
  return (
    <>
      <SectorHeader sector={sector} />
      {sector.segmentGroups.map((segmentGroup, segmentGroupIndex) => (
        <SegmentGroup
          // eslint-disable-next-line react/no-array-index-key
          key={segmentGroupIndex}
          segmentGroup={segmentGroup}
        />
      ))}
      {sector.stay && (
        <>
          {sector.stay.badges && <ItineraryBadgeList badges={sector.stay.badges} />}
          <ItinerarySeparator>
            <Text weight="bold">{sector.stay.title}</Text>
          </ItinerarySeparator>
        </>
      )}
    </>
  );
};

export default Sector;
